<section style="background-color: white;" class="section-container">
  <div class="container-fluid">
    <div class="row d-flex justify-content-center align-items-center h-100">
      <div class="col-md-9 col-lg-6 col-xl-5 text-center">
        <img [src]="logo()" class="img-fluid mx-auto mt-5 mt-xl-0" alt="Logo">
        <p class="display-6 mt-3 text-center">{{title()}}</p>
      </div>
      <div class="col-10 col-xs-6 col-md-8 col-lg-6 col-xl-4 offset-xl-1">
        <h2 class="h4 mb-3">{{'SET_PASSWORD_TITLE' | translation}}</h2>

        @switch (state()) {
          @case ('ready') {
            @if (requirementsText()) {
              <div class="alert alert-light" role="note" id="password-requirements" [innerHTML]="requirementsText() | safeHtml"></div>
            }

            <form (ngSubmit)="save()">
              <div class="form-outline mb-2">
                <label class="form-label" for="new-password">{{'SET_PASSWORD_NEW' | translation}}</label>
                <input [(ngModel)]="password" name="password" type="password" id="new-password"
                  autocomplete="new-password" aria-describedby="password-requirements"
                  class="form-control form-control-lg"
                  [class.is-valid]="meetsPolicy()" [class.is-invalid]="password() && !meetsPolicy()" />
                <div class="invalid-feedback">{{'SET_PASSWORD_POLICY' | translation}}</div>
              </div>

              <div class="form-outline mb-2">
                <label class="form-label" for="confirm-password">{{'SET_PASSWORD_CONFIRM' | translation}}</label>
                <input [(ngModel)]="confirmPassword" name="confirmPassword" type="password" id="confirm-password"
                  autocomplete="new-password" class="form-control form-control-lg"
                  [class.is-invalid]="confirmPassword() && !passwordsMatch()" />
                <div class="invalid-feedback">{{'SET_PASSWORD_MISMATCH' | translation}}</div>
              </div>

              @if (policyRejected()) {
                <div class="alert alert-danger mt-3" role="alert">{{'SET_PASSWORD_POLICY' | translation}}</div>
              }

              <div class="d-grid my-3">
                <button type="submit" class="btn btn-primary" [disabled]="!canSubmit()">
                  {{'SET_PASSWORD_SAVE' | translation}}
                </button>
              </div>
            </form>
          }
          @case ('invalid') {
            <div class="d-grid my-3">
              <a class="btn btn-primary" [routerLink]="forgotPasswordLink()">{{'ACTIVATION_LINK_NEW' | translation}}</a>
            </div>
          }
          @case ('error') {
            <div class="alert alert-danger" role="alert">{{'ERROR_GENERAL' | translation}}</div>
          }
          @case ('done') {
            <div class="alert alert-success" role="status">{{'SET_PASSWORD_DONE' | translation}}</div>
            <div class="d-grid my-3">
              <a class="btn btn-primary" [routerLink]="loginLink()">{{'LOGIN' | translation}}</a>
            </div>
          }
        }

        @if (state() !== 'done') {
          <p class="small fw-bold mt-2 pt-1">
            <a [routerLink]="loginLink()">{{'RETURN_TO_LOGIN' | translation}}</a>
          </p>
        }

        <div class="col-6">
          <app-language-selector></app-language-selector>
        </div>
      </div>
    </div>
  </div>
</section>
